import request from "@/utils/request";

// 新增或编辑流程图表
export function adjustFlowChart(data) {
  return request({
    url: "/opPlantsFlowChart/saveOrUpdateFlowChart",
    method: "post",
    data,
  });
}

// 删除图表
export function deleteFlowChart(id) {
  return request({
    url: `/opPlantsFlowChart/delete/${id}`,
    method: "delete",
  });
}
